import { render, staticRenderFns } from "./CheckoutFaqSidebar.vue?vue&type=template&id=4872e648&scoped=true&"
import script from "./CheckoutFaqSidebar.vue?vue&type=script&lang=js&"
export * from "./CheckoutFaqSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutFaqSidebar.vue?vue&type=style&index=0&id=4872e648&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4872e648",
  null
  
)

export default component.exports